import { NegativationDetails } from "../negativationDetails/negativatiosDetails";

export function NegativationDashboard() {
  return (
    <div className="relative flex justify-center w-full h-full overflow-y-auto bg-white dark:bg-white dark:text-black">
      <section className="max-w-7xl w-full p-2">
        <NegativationDetails />
      </section>
    </div>
  )
}